import { useQuery } from '@tanstack/react-query';
import api from '@/services/auth.service';
import type { ClienteMapa } from '../types/visita.types';
import { deviceTimezone } from './useAgenda';

// AIDEV-NOTE: Usa instancia axios (api) em vez de fetch nativo para respeitar VITE_API_URL.
// fetch com URL relativa quebrava em producao (frontend e API em dominios diferentes).
// tz do dispositivo para o flag tem_agenda_hoje usar o dia local (server roda em UTC)
async function fetchClientesMapa(): Promise<ClienteMapa[]> {
  const res = await api.get<{ data: ClienteMapa[] }>(
    `/visitas/clientes/mapa?tz=${encodeURIComponent(deviceTimezone())}`
  );
  return res.data.data;
}

export function useClientesMapa() {
  return useQuery({
    queryKey: ['clientes-mapa'],
    queryFn: fetchClientesMapa,
    staleTime: 5 * 60 * 1000 // 5 minutos
  });
}
